import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Body1, H4 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const GeneralErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.spacing.values.x40};
`;

export const ErrorTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${pxToRem(450)};
`;

export const MainText = styled(H4)`
  ${({ theme }) => `margin: 0 0 ${theme.spacing.values.half} 0`}
`;

export const CaptionText = styled(Body1)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  text-align: center;
`;

export const FallbackLink = styled(Link)`
  ${({ theme }) => theme.styles.links.link1}
`;
